import React, { useState } from "react";
import { FAQ } from "../../data/FAQ";
import style from "./FAQ.module.css";
import { useWebEngageTaraLandingFAQ } from "../../hooks/webengage";
const FAQComponent = () => {
  const { trackWebEngageTaraLandingFAQ } = useWebEngageTaraLandingFAQ();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleOpen = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
    trackWebEngageTaraLandingFAQ();
  };

  return (
    <div className={style.faq}>
      <div className={style.inner}>
        <div className={style.title}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/icon/question.svg`}
            alt=""
          />
          <h2 className={style.title}>سوالات متداول</h2>
        </div>
        <div className={style.items}>
          {FAQ.map((faq, index) => (
            <div key={index} className={style.item}>
              <div className={style.question} onClick={() => toggleOpen(index)}>
                <p> {faq.question}</p>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/icon/arrow-down.svg`}
                  alt=""
                  style={{
                    transform: openIndex === index ? "rotate(180deg)" : "",
                  }}
                />
              </div>
              {openIndex === index && (
                <div className={style.answer}>
                  <div className={style.line}></div>
                  <p>
                    {faq.answer}
                    </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQComponent;
